export default __webpack_public_path__ + "static/media/grocery.2ca486e9.jpg";